export const PRESIGNED_URL_KEYS_TO_UPLOAD = [
  "filePresignedUrl",
  "thumbnailPresignedUrl"
];

export const PRESIGNED_URL_KEYS_TO_UPLOAD_NAMES = {
  FILE_PRESIGNNED_URL: "filePresignedUrl",
  THUMBNAIL_PRESIGNED_URL: "thumbnailPresignedUrl"
};
